// ======================================================================
// File: src/components/Navbar.js
// Updated: 2025-12-01 — Added <LanguageSwitcher /> for multilingual support
// ======================================================================

import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Link } from "react-router-dom";
import LanguageSwitcher from "./LanguageSwitcher"; // 🌐 ADDED

function Navbar({ onScopeClick }) {
  const { user, permissions, logout } = useContext(AuthContext);

  const canView = (perm) => permissions?.[perm]?.view === true;

  return (
    <nav className="navbar navbar-expand-lg navbar-custom px-3">
      <a className="navbar-brand fw-bold text-white" href="/dashboard">
        TaskFlow
      </a>

      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarMenu"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="navbarMenu">
        <ul className="navbar-nav me-auto mb-2 mb-lg-0">

          {/* Existing Menus */}
          {canView("TASK_VIEW") && (
            <li className="nav-item">
              <Link className="nav-link text-white" to="/tasks">
                Tasks
              </Link>
            </li>
          )}

          {canView("REPORT_VIEW") && (
            <li className="nav-item">
              <Link className="nav-link text-white" to="/reports">
                Reports
              </Link>
            </li>
          )}

          {/* ⭐ Visitor Management Module */}
          {canView("VISITOR_VIEW") && (
            <li className="nav-item">
              <Link className="nav-link text-white" to="/visitor/dashboard">
                Visitor
              </Link>
            </li>
          )}

          {/* ⭐ Ticket Module Menu Entry */}
          {canView("TICKET_VIEW") && (
            <li className="nav-item">
              <Link className="nav-link text-white" to="/tickets">
                Tickets
              </Link>
            </li>
          )}
          {/* ⭐ Invoice Management Module */}
          {canView("INVOICE_VIEW") && (
            <li className="nav-item">
              <Link className="nav-link text-white" to="/invoices">
                Invoices
              </Link>
            </li>
          )}

          {canView("PPE_VIEW_DASHBOARD") && (
            <li className="nav-item">
              <Link className="nav-link text-white" to="/ppe/dashboard">
              PPE
          </Link>
           </li>
           )}
          
         {canView("PPE_VIEW_DASHBOARD") && (
          <li className="nav-item">
            <Link className="nav-link text-white" to="/ipe/dashboard">
              IPE
            </Link>
          </li>
        )}

        {/* ⭐ Service CRM Module SERVICE_CRM_DASHBOARD */}
           
        {/* ⭐ Service CRM Module */}
        {
          (
            canView("SCM_DASHBOARD") ||
            canView("SERVICE_TICKET") ||
            canView("SERVICE_VISIT") ||
            canView("SERVICE_FEEDBACK") ||
            canView("SERVICE_SATISFACTION") ||
            canView("SCM_INSTALLED_PRODUCT") ||
            canView("SCM_REPORT_INSTALLED_PRODUCTS") ||
            canView("SCM_REPORT_TICKETS") ||
            canView("SCM_REPORT_FEEDBACK") ||
            canView("SCM_REPORT_SATISFACTION") ||
            canView("SCM_BUSINESS_PARTNER") ||
            canView("SCM_SLA_MANAGE")
          ) && (
            <li className="nav-item">
              <Link
                className="nav-link text-white"
                to="/service-crm/dashboard"
              >
                Service CRM
              </Link>
            </li>
          )
        }

        {/* ⭐ WMS Module */}
        {
          (
            canView("WMS_DASHBOARD") ||
            canView("WMS_MY_WORK") ||
            canView("WMS_WORK") ||
            canView("WMS_TEMPLATE") ||
            canView("WMS_CHECKLIST") ||
            canView("WMS_TEAM") ||
            canView("WMS_CALENDAR") ||
            canView("WMS_SLA") ||
            canView("WMS_ESCALATION") ||
            canView("WMS_REPORT")
          ) && (
            <li className="nav-item">
              <Link
                className="nav-link text-white"
                //to="/wms/dashboard"
                to="/wms/my-work"
              >
                WMS
              </Link>
            </li>
          )
        }
        
        
        {/* ELOSCA CRM Module */}
        {(
          canView("WMS_DASHBOARD") ||
          canView("ELOSCA_CRM_DASHBOARD") ||
          canView("ELOSCA_ENQUIRY_VIEW") ||
          canView("ELOSCA_ENQUIRY_CREATE")
        ) && (
          <li className="nav-item">
            <Link
              className="nav-link text-white"
              to="/elosca-crm/enquiry"
            >
              ELOSCA CRM
            </Link>
          </li>
        )}

        {/* Trading Module */}
{(
  canView("WMS_DASHBOARD") ||
  canView("TRADING_DASHBOARD") ||
  canView("TRADING_ENQUIRY_VIEW") ||
  canView("TRADING_ENQUIRY_CREATE")
) && (
  <li className="nav-item">
    <Link
      className="nav-link text-white"
      to="/trading"
    >
      Trading
    </Link>
  </li>
)}

      


{/* Certificate Management Module */}
{(
  canView("WMS_DASHBOARD") ||
  canView("ASSET_CERTIFICATES")
) && (
  <li className="nav-item">
    <Link
      className="nav-link text-white"
      to="/assets/certificate-management"
    >
      Certificate Management
    </Link>
  </li>
)}

        {/* ⭐ Expense Management Module */}
        {
          (
            canView("EXP_DASHBOARD") ||
            canView("EXP_MY_EXPENSES") ||
            canView("EXP_EXPENSE_CLAIMS") ||
            canView("EXP_EXPENSE_ADVANCES") ||
            canView("EXP_EXPENSE_APPROVALS") ||
            canView("EXP_EXPENSE_PAYMENTS") ||
            canView("EXP_EXPENSE_SETTLEMENTS") ||

            canView("EXP_REPORT_REGISTER") ||
            canView("EXP_REPORT_CLAIMS") ||
            canView("EXP_REPORT_APPROVALS") ||
            canView("EXP_REPORT_PAYMENTS") ||
            canView("EXP_REPORT_ADVANCES") ||
            canView("EXP_REPORT_SETTLEMENTS") ||
            canView("EXP_REPORT_MILEAGE") ||
            canView("EXP_REPORT_PER_DIEM") ||
            canView("EXP_REPORT_POLICY_VIOLATION") ||

            canView("EXP_CATEGORY") ||
            canView("EXP_TYPE") ||
            canView("EXP_PAYMENT_MODE") ||
            canView("EXP_CURRENCY") ||
            canView("EXP_MILEAGE_RATE") ||
            canView("EXP_PER_DIEM_RATE") ||
            canView("EXP_TAX") ||
            canView("EXP_VENDOR") ||
            canView("EXP_COST_CENTER") ||
            canView("EXP_PROJECT") ||
            canView("EXP_EXPENSE_REASON") ||
            canView("EXP_RECEIPT_TYPE") ||
            canView("EXP_APPROVAL_LEVEL") ||
            canView("EXP_REIMBURSEMENT_METHOD") ||
            canView("EXP_EXPENSE_POLICY") ||
            canView("EXP_EXPENSE_POLICY_RULE") ||

            canView("EXP_APPROVAL_WORKFLOW") ||
            canView("EXP_APPROVAL_RULES") ||
            canView("EXP_NUMBER_SERIES") ||
            canView("EXP_SETTINGS") ||
            canView("EXP_NOTIFICATION_RULES") ||
            canView("EXP_POLICY_CONFIGURATION")
          ) && (
            <li className="nav-item">
              <Link
                className="nav-link text-white"
                to="/expense-management/dashboard"
              >
                Expense
              </Link>
            </li>
          )
        }
        
        {/* ⭐ Finance Module */}
        {
          (
            canView("FIN_DASHBOARD") ||
            canView("WMS_DASHBOARD") ||  
            canView("FIN_MANUAL_JOURNAL") ||
            canView("FIN_PAYMENT_VOUCHER") ||
            canView("FIN_RECEIPT_VOUCHER") ||
            canView("FIN_CONTRA_VOUCHER") ||
            canView("FIN_DEBIT_NOTE") ||
            canView("FIN_CREDIT_NOTE") ||

            canView("FIN_COMPANY") ||
            canView("FIN_FINANCIAL_YEAR") ||
            canView("FIN_FINANCIAL_PERIOD") ||
            canView("FIN_CURRENCY") ||
            canView("FIN_EXCHANGE_RATE") ||
            canView("FIN_ACCOUNT_GROUP") ||
            canView("FIN_CHART_OF_ACCOUNT") ||
            canView("FIN_COST_CENTER") ||
            canView("FIN_BANK") ||
            canView("FIN_BANK_ACCOUNT") ||
            canView("FIN_FINANCE_EVENT") ||
            canView("FIN_POSTING_RULE") ||

            canView("FIN_REPORT") ||
            canView("FIN_SETTINGS")
          ) && (
            <li className="nav-item">
              <Link
                className="nav-link text-white"
                to="/finance/dashboard"
              >
                Finance
              </Link>
            </li>
          )
        }
        
        {/* ⭐ Campaign Module */}
        {
          (
            canView("CAMPAIGN_DASHBOARD") ||
            canView("CAMPAIGN_PROSPECT_IMPORT") ||
            canView("CAMPAIGN_REPORT") ||
            canView("CAMPAIGN_SETTINGS")
          ) && (
            <li className="nav-item">
              <Link
                className="nav-link text-white"
                to="/campaign/dashboard"
              >
                Campaign
              </Link>
            </li>
          )
        }

        </ul>

        {/* Right Side — Language, User, Scope, Logout */}
        <div className="d-flex align-items-center gap-3">

          {/* 🌐 Language Switcher — ADDED */}
          <LanguageSwitcher />

          <span className="text-white fw-semibold d-none d-md-block">
            👋 {user?.username}
          </span>

          <button className="btn btn-sm btn-scope" onClick={onScopeClick}>
            <i className="fas fa-globe me-1"></i> Scope
          </button>

          <button
            className="btn btn-sm btn-danger"
            onClick={() => {
              logout();
              window.location.href = "/login";
            }}
          >
            <i className="fas fa-sign-out-alt me-1"></i> Logout
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
